import React, { useContext } from 'react';
import { QuizContext } from '../contexts/quizContext'

import Confetti from 'react-dom-confetti';

import ScoreBoard from './ScoreBoard'
import TrueFalseChoices from './TrueFalseChoices'

export default function Quiz() {
  const { quiz, dispatch } = useContext(QuizContext)

  const resetQuiz = () => dispatch({ type: "RESET_QUIZ" })
  const updateNumbers = () => dispatch({ type: "UPDATE_NUMBERS" })

  const handleSubmit = (event) => {
    event.preventDefault()
    if (quiz.chosenAnswer !== null) {
      dispatch({ type: "SUBMIT_ANSWER" })
    }
    dispatch({ type: "ADD_SCORE", score: ( isCorrect() ? 1 : 0) })
  }

  const isCorrect = () => quiz.chosenAnswer === quiz.correctAnswer

  const handleNext = (event) => {
    event.preventDefault()
    resetQuiz()
    updateNumbers()
  }

  return(
    <div className="question-block">
      <ScoreBoard />

      <form id="new_result" className="new_result" action="" method="post">
        <div className="question">
          <h2>
            {quiz.target} x {quiz.multiplier}<br />
            =
          </h2>
        </div>

        {quiz.mode === 'true-false' && <TrueFalseChoices />}     
        
        <div className="answer clear">
          { !quiz.submitted && (
            <div className="col-sm-6 col-sm-offset-3 button-row">
              <input type="submit"
                    value="Submit Answer"
                    className={ quiz.chosenAnswer === null ? `button solid-button purple disabled` : `button solid-button purple`}
                    onClick={handleSubmit} />
            </div>
          ) }

          <Confetti active={ quiz.submitted && isCorrect() } config={ { duration: "2000", angle: "36" } } />

          { quiz.submitted && (
            <div className="row result-row">
              <h4 className={ isCorrect() ? `text-success text-center` : `text-danger text-center`}>
                <i className={ isCorrect() ? `md md-grade` : `md md-highlight-remove`}></i> 
                { isCorrect() ? `Correct` : `Wrong`}! The right answer is '{ quiz.correctAnswer }'
              </h4>

              <h3 className={ isCorrect() ? `text-success text-center` : `text-danger text-center`}>
                <strong>
                  {quiz.target} x {quiz.multiplier} = {quiz.target * quiz.multiplier}
                </strong>
              </h3>

              <div className="button-row">
                <a href="#next" className="button solid-button purple" onClick={handleNext}>Next Question</a>
              </div>
            </div>
          )}

		    </div>
      </form>

    </div>
  )

}
